<template>
  <div :style="fullscreen ? fullStyle : null">
    <div v-if="fullscreen" class="d-flex justify-end">
      <v-btn text color="primary" @click="$emit('close')">
        <v-icon left>mdi-keyboard-return</v-icon> Cerrar Vista
      </v-btn>
    </div>
    <div v-if="showFilters" class="col-12 d-flex align-center justify-center">
      <VueCtkDateTimePicker v-model="filtros.desde" label="Desde" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
        noHeader overlay :disabled="loadingTabla" />

      <VueCtkDateTimePicker v-model="filtros.hasta" label="Hasta" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
        noHeader overlay class="mx-2" :disabled="loadingTabla" />


      <v-autocomplete v-model="filtros.maquinas" :items="instancias" :item-text="nombreMaquina"
        item-value="idMaquinaIns" label="Máquina (opcional)" clearable multiple chips dense class="mr-2"
        style="min-width: 400px;" :loading="loadingInstancias" />

      <v-autocomplete v-model="filtros.areas" :items="areas" item-text="nombre" item-value="idArea"
        label="Áreas (opcional)" clearable multiple chips dense class="mr-2" style="min-width: 400px;"
        :loading="loadingAreas" />

      <v-btn color="primary" :disabled="!validForm" :loading="loadingTabla" @click="searchData()">
        Buscar
      </v-btn>
    </div>
    <v-row v-if="oeeTM">
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-card class="pa-4" outlined rounded="lg" elevation="1">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-avatar color="primary" size="32" class="mr-3"><v-icon
                      color="white">mdi-speedometer</v-icon></v-avatar>
                  <div class="text-subtitle-2">OEE Global</div>
                </div>
                <div class="text-h6 font-weight-bold">{{ fmtPct(oeeGlobal) }}</div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="pa-4" outlined rounded="lg" elevation="1">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-avatar color="deep-purple" size="32" class="mr-3"><v-icon
                      color="white">mdi-timer-off</v-icon></v-avatar>
                  <div class="text-subtitle-2">Paros No Programados</div>
                </div>
                <div class="text-h6 font-weight-bold">{{ fmtDur(segMuertosTotal) }}</div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="pa-4" outlined rounded="lg" elevation="1">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-avatar color="orange" size="32" class="mr-3">
                    <v-icon color="white">mdi-tools</v-icon>
                  </v-avatar>
                  <div class="text-subtitle-2">Paro Programado</div>
                </div>
                <div class="text-h6 font-weight-bold">{{ fmtDur(segParoProgramadoTotal) }}</div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card class="pa-4" outlined rounded="lg" elevation="1">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-avatar color="success" size="32" class="mr-3">
                    <v-icon color="white">mdi-shield-check</v-icon>
                  </v-avatar>
                  <div class="text-subtitle-2">FTQ</div>
                </div>
                <div class="text-h6 font-weight-bold">
                  {{ det.length ? fmtPct(calidadGlobal) : '—' }}
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <!-- Columna izquierda (paneles verticales) -->
      <v-col v-if="false" cols="12" md="3">
        <v-row dense>
          <v-col cols="12"><v-card class="pa-4" style="height: 100px;">Operating</v-card></v-col>
          <v-col cols="12"><v-card class="pa-4" style="height: 100px;">Performance</v-card></v-col>
          <v-col cols="12"><v-card class="pa-4" style="height: 100px;">Status</v-card></v-col>

          <v-col cols="12"><v-card class="pa-4" style="height: 260px;">Production (Donut)</v-card></v-col>
          <v-col cols="12"><v-card class="pa-4" style="height: 140px;">Rate / Output / Defects</v-card></v-col>
        </v-row>
      </v-col>

      <!-- Columna derecha (contenido principal) -->
      <v-col cols="12" md="12">
        <v-row>
          <!-- 4 tarjetas pequeñas a la izquierda -->
          <v-col cols="12" md="4">
            <div class="kpi-grid">
              <v-card class="pa-4" outlined rounded="lg" elevation="1">
                <v-row no-gutters align="center" class="mb-2">
                  <v-col class="d-flex align-center">
                    <v-icon left color="primary">mdi-check-circle</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Piezas OK</span>
                  </v-col>
                  <v-col class="text-right">
                    <v-chip color="primary" text-color="white" label small class="font-weight-bold">
                      Total: {{ num(totalHechas) }}
                    </v-chip>
                  </v-col>
                </v-row>

                <v-row dense>
                  <!-- IZQUIERDA -->
                  <v-col cols="12" sm="12">
                    <v-card color="indigo lighten-5" outlined rounded="lg" class="pa-3">
                      <div class="d-flex align-center">
                        <v-avatar color="indigo" size="28" class="mr-3">
                          <v-icon color="white" small>mdi-arrow-left-bold</v-icon>
                        </v-avatar>
                        <div class="flex-grow-1">
                          <div class="caption text--secondary">Izquierda</div>
                          <div class="text-h6 font-weight-bold mb-1">{{ num(izqHechas) }}</div>
                          <v-progress-linear :value="pIzqHechas" height="6" color="indigo"></v-progress-linear>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <!-- DERECHA -->
                  <v-col cols="12" sm="12">
                    <v-card color="teal lighten-5" outlined rounded="lg" class="pa-3">
                      <div class="d-flex align-center">
                        <v-avatar color="teal" size="28" class="mr-3">
                          <v-icon color="white" small>mdi-arrow-right-bold</v-icon>
                        </v-avatar>
                        <div class="flex-grow-1">
                          <div class="caption text--secondary">Derecha</div>
                          <div class="text-h6 font-weight-bold mb-1">{{ num(derHechas) }}</div>
                          <v-progress-linear :value="pDerHechas" height="6" color="teal"></v-progress-linear>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
              <v-card class="pa-4" outlined rounded="lg" elevation="1">
                <v-row no-gutters align="center" class="mb-2">
                  <v-col class="d-flex align-center">
                    <v-icon left color="error">mdi-delete-circle-outline</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Piezas SCRAP</span>
                  </v-col>
                  <v-col class="text-right">
                    <v-chip color="error" text-color="white" label small class="font-weight-bold">
                      Total: {{ num(totalScrap) }}
                    </v-chip>
                  </v-col>
                </v-row>

                <v-row dense>
                  <!-- IZQUIERDA -->
                  <v-col cols="12" sm="12">
                    <v-card color="orange darken-4" rounded="lg" class="pa-3">
                      <div class="d-flex align-center">
                        <v-avatar color="red" size="28" class="mr-3">
                          <v-icon color="white" small>mdi-arrow-left-bold</v-icon>
                        </v-avatar>
                        <div class="flex-grow-1">
                          <div class="caption text--secondary">Izquierda</div>
                          <div class="text-h6 font-weight-bold mb-1">{{ num(izqScrap) }}</div>
                          <v-progress-linear :value="pIzqScrap" height="6" color="red"></v-progress-linear>
                        </div>
                      </div>
                    </v-card>
                  </v-col>

                  <!-- DERECHA -->
                  <v-col cols="12" sm="12">
                    <v-card color="deep-orange lighten-3" rounded="lg" class="pa-3">
                      <div class="d-flex align-center">
                        <v-avatar color="deep-orange" size="28" class="mr-3">
                          <v-icon color="white" small>mdi-arrow-right-bold</v-icon>
                        </v-avatar>
                        <div class="flex-grow-1">
                          <div class="caption text--secondary">Derecha</div>
                          <div class="text-h6 font-weight-bold mb-1">{{ num(derScrap) }}</div>
                          <v-progress-linear :value="pDerScrap" height="6" color="deep-orange"></v-progress-linear>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-col>

          <!-- Tarjeta grande "OEE Overview" a la derecha -->
          <v-col cols="12" md="8">
            <v-card class="pa-4" style="height: 100%;">
              <!-- <v-card-title class="text-subtitle-1">OEE Por Máquina</v-card-title> -->
              <div class="text-subtitle-1 font-weight-bold mb-2">OEE Por Máquina</div>
              <v-card-text>
                <apexchart type="bar" height="350" :options="chartOptionsOee" :series="seriesOee" />
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Tarjeta grande "Máquina" (heatmap + línea + tabla) -->
          <v-col cols="12">
            <v-card class="pa-0" style="height: auto;">
              <!-- Cabecera -->
              <v-sheet class="d-flex align-center justify-space-between px-4 py-3">
                <div class="text-subtitle-1 font-weight-bold">Piezas Totales Por Día</div>
                <!-- <div class="text-caption">Controles / Rango / Leyenda</div> -->
              </v-sheet>
              <v-divider />

              <!-- Contenido -->
              <v-row dense class="px-4 pt-3">
                <!-- <v-col cols="12">
                  <v-sheet style="height: 70px;" class="pa-2">Heatmap OEE (tu tabla)</v-sheet>
                </v-col> -->
                <v-col cols="12">
                  <!-- <v-sheet style="height: 220px;" class="pa-2">Línea Pzas OK Izq/Der (Apex)</v-sheet> -->
                  <apexchart type="line" height="400" width="100%" :options="chartOptsPzas" :series="seriesPzas" />
                </v-col>
              </v-row>

              <v-divider />
              <v-sheet class="px-4 py-5">
                <div class="text-subtitle-1 font-weight-bold mb-2">OEE Por Día y Máquina</div>
                <!-- <v-sheet style="height: 110px;">Tabla inferior (resumen)</v-sheet> -->
                <v-sheet class="oee-wrapper elevation-1 rounded-lg">
                  <v-simple-table v-if="rowsNorm.length" dense class="oee-table">
                    <thead>
                      <tr>
                        <th class="sticky-col left-col text-left" style="background-color: white; z-index: 100;">
                          <span class="th-title">Máquina</span>
                        </th>
                        <th v-for="f in fechas" :key="f" class="text-center th-date">
                          {{ formatFecha(f) }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="m in maquinasPivot" :key="m.nombre">
                        <td class="sticky-col left-col left-text">
                          {{ m.nombre }}
                        </td>

                        <td v-for="f in fechas" :key="m.nombre + '_' + f" class="oee-cell text-center"
                          :style="{ backgroundColor: cellBg(m.oeePorFecha[f]), color: cellFg(m.oeePorFecha[f]) }"
                          :title="m.oeePorFecha[f] != null ? m.oeePorFecha[f].toFixed(2) + '%' : 'Sin dato'">
                          <span class="num">
                            {{ m.oeePorFecha[f] != null ? m.oeePorFecha[f].toFixed(2) + '%' : '—' }}
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-sheet>
              </v-sheet>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    showFilters: { type: Boolean, default: true },
    fullscreen: { type: Boolean, default: false }
  },
  data() {
    return {
      filtros: {
        desde: null,
        hasta: null,
        maquinas: [],
        menorAMayor: true
      },

      instancias: [],
      areas: [],

      oeeTM: null,
      ftq: null,
      hastaFinal: null,

      loadingInstancias: false,
      loadingAreas: false,
      loadingTabla: false,

    }
  },
  mounted() {
    this.initialize();
  },
  computed: {
    validForm() {
      const f = this.filtros;
      if (!f.desde || !f.hasta) return false;

      // Normaliza para evitar ambigüedad del parser
      const desde = new Date(String(f.desde).replace(' ', 'T'));
      const hasta = new Date(String(f.hasta).replace(' ', 'T'));
      return hasta > desde;
    },

    // Normaliza la respuesta: acepta array directo o {detallesPorDias: [...]}
    rowsNorm() {
      if (!this.oeeTM) return [];
      if (Array.isArray(this.oeeTM)) return this.oeeTM;
      if (Array.isArray(this.oeeTM.detallesPorDias)) return this.oeeTM.detallesPorDias;
      return [];
    },

    // Claves de fecha seguras para ordenar (YYYY-MM-DD)
    fechas() {
      const keys = new Set(this.rowsNorm.map(r => String(r.inicio).slice(0, 10)));
      return Array.from(keys).sort(); // orden cronológico por ISO
    },

    // Pivote: { nombre, oeePorFecha: { 'YYYY-MM-DD': promedioOEE } }
    maquinasPivot() {
      const acc = {}; // { nombre: { fechaKey: {sum, n} } }
      this.rowsNorm.forEach(r => {
        // Excluir filas "sin datos" (sin actividad) del mapa de calor.
        if (r.sinDatos) return;
        const fechaKey = String(r.inicio).slice(0, 10);
        const nombre = r.nombre;
        acc[nombre] = acc[nombre] || {};
        acc[nombre][fechaKey] = acc[nombre][fechaKey] || { sum: 0, n: 0 };
        acc[nombre][fechaKey].sum += Number(r.oee) || 0;
        acc[nombre][fechaKey].n += 1;
      });

      return Object.keys(acc)
        .sort()
        .map(nombre => {
          const oeePorFecha = {};
          this.fechas.forEach(f => {
            oeePorFecha[f] = acc[nombre][f]
              ? acc[nombre][f].sum / acc[nombre][f].n
              : null;
          });
          return { nombre, oeePorFecha };
        });
    },

    fullStyle() {
      return {
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 2001,
        background: this.$vuetify?.theme?.dark ? '#121212' : '#fff',
        padding: '16px',
        overflow: 'auto'
      }
    },


    piezasOkPorDia() {
      // Map 'YYYY-MM-DD' -> { izq, der }
      const acc = new Map();

      const add = (day, side, val) => {
        if (!acc.has(day)) acc.set(day, { izq: 0, der: 0 });
        acc.get(day)[side] += Number(val) || 0;
      };

      for (const r of this.rowsNorm) {
        const day = this.getDayKey(r);          // usa inicio/fechaX...
        if (!day) continue;

        // valor OK en tu payload
        const ok = Number(r.piezasReales ?? r.pzaRealizadas ?? r.pzasOk ?? r.ok ?? 0);

        // lado a partir de 'cavidad' (Izquierda/Derecha)
        const side = this.getSide(r);
        if (!side) continue;

        add(day, side, ok);
      }

      // Usa las mismas fechas de tu tabla para alinear
      const days = (this.fechas && this.fechas.length)
        ? this.fechas
        : Array.from(acc.keys()).sort();

      const izq = days.map(d => acc.get(d)?.izq ?? 0);
      const der = days.map(d => acc.get(d)?.der ?? 0);

      // (opcional) debug si todo es cero y sí hay data
      if (this.rowsNorm.length && izq.concat(der).every(v => v === 0)) {
        console.warn('[PiezasOK] Revisa que vengan piezasReales y cavidad en cada fila. Ejemplo:', this.rowsNorm[0]);
      }

      return { days, izq, der };
    },

    // === 2) Series para ApexCharts ===
    seriesPzas() {
      const { izq, der } = this.piezasOkPorDia;
      return [
        { name: 'Pzas OK Izquierda', data: izq },
        { name: 'Pzas OK Derecha', data: der }
      ];
    },

    // === 3) Opciones del chart (categorías = días) ===
    chartOptsPzas() {
      return {
        chart: { height: 350, type: 'line' },
        plotOptions: { line: { isSlopeChart: true } },
        xaxis: {
          categories: this.piezasOkPorDia.days.map(this.formatFecha),
          position: 'bottom',
          labels: { rotate: -15 }
        },
        yaxis: {
          labels: { formatter: v => Math.round(v).toLocaleString('es-MX') }
        },
        tooltip: { followCursor: true, intersect: false, shared: true },
        legend: { show: true, position: 'top', horizontalAlign: 'left' },
        stroke: { width: [3, 3], dashArray: [0, 4], curve: 'smooth' },
        markers: {
          size: 6,
        },
        dataLabels: {
          background: { enabled: true },
          formatter: (val, opts) => {
            const i = opts.dataPointIndex;
            const last = opts.w.globals.series[opts.seriesIndex].length - 1;
            return (i === 0 || i === last) ? Math.round(val).toLocaleString('es-MX') : '';
          }
        }
      };
    },

    oeeRows() {
      // Fuente tolerante: oeeTm.detalles, oeeTM.detalles o arreglo directo
      const src =
        (Array.isArray(this.oeeTm?.detalles) && this.oeeTm.detalles) ||
        (Array.isArray(this.oeeTM?.detalles) && this.oeeTM.detalles) ||
        (Array.isArray(this.oeeTm) && this.oeeTm) ||
        (Array.isArray(this.oeeTM) && this.oeeTM) ||
        [];

      return src
        .filter(d => !d?.sinDatos) // excluir máquinas "sin datos" (sin actividad)
        .map(d => ({
          name: String(d?.nombre ?? ''),
          val: Math.max(0, Math.min(100, Number(d?.oee) || 0)) // 0..100
        }))
        .sort((a, b) => b.val - a.val);
    },
    seriesOee() {
      return [
        {
          name: 'OEE',
          data: this.oeeRows.map(r => Number(r.val.toFixed(2)))
        }
      ];
    },
    chartOptionsOee() {
      const categories = this.oeeRows.map(r => r.name);

      return {
        chart: { type: 'bar', height: 350, animations: { enabled: true } },
        noData: {
          text: 'Sin datos',
          align: 'center',
          verticalAlign: 'middle',
          style: { fontSize: '13px', fontWeight: 600 }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 6,
            barHeight: '70%',
            dataLabels: { position: 'right' },
            colors: {
              ranges: [
                { from: 0, to: 49.999, color: '#c62828' },
                { from: 50, to: 69.999, color: '#ef6c00' },
                { from: 70, to: 84.999, color: '#f1c40f' },
                { from: 85, to: 100, color: '#2e7d32' }
              ]
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: v => `${v.toFixed(1)}%`,
          offsetX: 8,                         // separa la etiqueta del extremo de la barra
          background: {
            enabled: true,
            foreColor: '#111',                // texto negro
            padding: 6,
            borderRadius: 6,
            borderWidth: 0,
            opacity: 0.95,
            dropShadow: { enabled: true, top: 0, left: 0, blur: 2, opacity: 0.25 }
          },
          style: { fontSize: '13px', fontWeight: 800 }
        },
        xaxis: {
          categories,
          max: 100,
          tickAmount: 5,
          labels: { formatter: v => `${Math.round(v)}%` }
        },
        yaxis: { labels: { style: { fontWeight: 700 } } },
        tooltip: { y: { formatter: v => `${v.toFixed(2)}%` } },
        legend: { show: false },
        grid: { strokeDashArray: 3 }
      };

    },
    detDias() {
      const d = this.oeeTM?.detallesPorDias;
      return Array.isArray(d) ? d : [];
    },

    // --- Totales de piezas OK ---
    totalHechas() {
      return this.detDias.reduce((s, r) => s + (Number(r.piezasReales) || 0), 0);
    },
    // Sumas por lado (OK y Teóricas)
    _sumTeoIzq() {
      return this.detDias.reduce((s, r) =>
        /izq|izquierda/i.test(String(r.cavidad || '')) ? s + (Number(r.piezasTeoricas) || 0) : s, 0);
    },
    _sumTeoDer() {
      return this.detDias.reduce((s, r) =>
        /der|derecha/i.test(String(r.cavidad || '')) ? s + (Number(r.piezasTeoricas) || 0) : s, 0);
    },
    izqHechas() {
      return this.detDias.reduce((s, r) =>
        /izq|izquierda/i.test(String(r.cavidad || '')) ? s + (Number(r.piezasReales) || 0) : s, 0);
    },
    derHechas() {
      return this.detDias.reduce((s, r) =>
        /der|derecha/i.test(String(r.cavidad || '')) ? s + (Number(r.piezasReales) || 0) : s, 0);
    },
    // % de avance vs. teóricas (para v-progress-linear: 0–100)
    pIzqHechas() {
      const teo = this._sumTeoIzq;
      return teo > 0 ? Math.round((this.izqHechas / teo) * 100) : 0;
    },
    pDerHechas() {
      const teo = this._sumTeoDer;
      return teo > 0 ? Math.round((this.derHechas / teo) * 100) : 0;
    },

    // --- SCRAP (si el payload trae piezasNoOk / scrap) ---
    totalScrap() {
      const has = this.detDias.some(r =>
        r.piezasNoOk != null || r.pzasNoOk != null || r.noOk != null || r.scrap != null
      );
      if (!has) return null;
      return this.detDias.reduce((s, r) => {
        const v = r.piezasNoOk ?? r.pzasNoOk ?? r.noOk ?? r.scrap;
        return s + (Number(v) || 0);
      }, 0);
    },
    izqScrap() {
      if (this.totalScrap == null) return null;
      return this.detDias.reduce((s, r) => {
        if (!/izq|izquierda/i.test(String(r.cavidad || ''))) return s;
        const v = r.piezasNoOk ?? r.pzasNoOk ?? r.noOk ?? r.scrap;
        return s + (Number(v) || 0);
      }, 0);
    },
    derScrap() {
      if (this.totalScrap == null) return null;
      return this.detDias.reduce((s, r) => {
        if (!/der|derecha/i.test(String(r.cavidad || ''))) return s;
        const v = r.piezasNoOk ?? r.pzasNoOk ?? r.noOk ?? r.scrap;
        return s + (Number(v) || 0);
      }, 0);
    },
    pIzqScrap() {
      const teo = this._sumTeoIzq;
      return this.totalScrap != null && teo > 0 ? Math.round((this.izqScrap / teo) * 100) : 0;
    },
    pDerScrap() {
      const teo = this._sumTeoDer;
      return this.totalScrap != null && teo > 0 ? Math.round((this.derScrap / teo) * 100) : 0;
    },

    det() {
      const d = this.oeeTM?.detalles;
      // Excluir máquinas "sin datos" (sin actividad): tienen segundosAnalizados > 0 pero oee = 0,
      // así que arrastrarían el OEE global ponderado hacia abajo.
      return Array.isArray(d) ? d.filter(r => !r?.sinDatos) : [];
    },

    // OEE Global ponderado por tiempo analizado
    oeeGlobal() {
      const totT = this.det.reduce((s, r) => s + (Number(r.segundosAnalizados) || 0), 0);
      if (!totT) {
        const arr = this.det.map(r => Number(r.oee) || 0);
        return arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : 0;
      }
      const num = this.det.reduce((s, r) =>
        s + ((Number(r.oee) || 0) * (Number(r.segundosAnalizados) || 0)), 0);
      return num / totT; // en %
    },
    calidadGlobal() {
      if (!this.det.length) return 0;

      // Igual que OEE: promedio ponderado por segundos analizados
      const totT = this.det.reduce(
        (s, r) => s + (Number(r.segundosAnalizados) || 0),
        0
      );

      if (!totT) {
        // fallback: promedio simple de la columna calidad
        const arr = this.det.map(r => Number(r.calidad) || 0);
        return arr.length ? arr.reduce((a, b) => a + b, 0) / arr.length : 0;
      }

      const num = this.det.reduce(
        (s, r) =>
          s + ((Number(r.calidad) || 0) * (Number(r.segundosAnalizados) || 0)),
        0
      );

      return num / totT;
    },


    // Acumulados de tiempo (en segundos)
    segMuertosTotal() {
      return this.det.reduce((s, r) => s + (Number(r.segundosMuertos) || 0), 0);
    },
    segParosAgendaTotal() {
      return this.det.reduce((s, r) => s + (Number(r.segundosParosProgAgenda) || 0), 0);
    },
    segParosProgTotal() {
      return this.det.reduce((s, r) => s + (Number(r.segundosParosProgReales) || 0), 0);
    },

    segParoProgramadoTotal() {
      return (Number(this.segParosAgendaTotal) || 0) + (Number(this.segParosProgTotal) || 0);
    },

    nowStr() {
      // Devuelve ahora en "YYYY-MM-DD HH:mm"
      const d = new Date();
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    maxDesde() {
      // Para "desde": máximo = hasta (si existe) o ahora
      return this.filtros.hasta || this.nowStr;
    }
  },
  methods: {
    num(v) { return Number(v).toLocaleString('es-MX'); },
    nombreMaquina: m => `[${m.nombre}] - ${m.marca} ${m.modelo}`,

    initialize() {
      this.getInstancias();
      this.getAreas();
    },

    getInstancias() {
      this.loadingInstancias = true;
      axios
        .get('/MaquinaInstancias/ComboOee')
        .then(res => (this.instancias = res.data))
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingInstancias = false;   // <= corregido
        });
    },
    getAreas() {
      this.loadingAreas = true;
      axios
        .get('/Areas')
        .then(res => (this.areas = res.data))
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingAreas = false;   // <= corregido
        });
    },

    searchData() {
      const { desde, hasta } = this.filtros;

      // Ajusta “hasta” si supera el momento actual
      const pad = n => String(n).padStart(2, '0');
      const now = new Date();
      const hDate = new Date(String(hasta).replace(' ', 'T'));
      const hastaFinal =
        hDate > now
          ? `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(
            now.getHours()
          )}:${pad(now.getMinutes())}`
          : hasta;
      this.hastaFinal = hastaFinal;

      this.getOEETM(desde, hastaFinal);
      // this.getFTQ(desde, hastaFinal);
    },

    getOEETM(desde, hasta) {
      this.oeeTM = null;
      this.loadingTabla = true;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);

      const maquinas = this.filtros.maquinas || [];
      const idsMaquinasQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      const areas = this.filtros.areas || [];
      const idsAreasQS = areas.map(id => `idAreas=${encodeURIComponent(id)}`).join('&');

      const params = [
        `desde=${desdeQS}`,
        `hasta=${hastaQS}`,
        idsMaquinasQS,
        idsAreasQS
      ].filter(Boolean).join('&');

      axios
        .get(`/Reportes/ObtenerResumenOEETMNyx?${params}`)
        .then(res => (this.oeeTM = res.data))
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingTabla = false;
        });
    },
    getFTQ(desde, hasta) {
      this.ftq = null;

      const desdeQS = encodeURIComponent(desde);
      const hastaQS = encodeURIComponent(hasta);

      const maquinas = this.filtros.maquinas || [];
      const idsMaquinasQS = maquinas.map(id => `idMaquinas=${encodeURIComponent(id)}`).join('&');

      const areas = this.filtros.areas || [];
      const idsAreasQS = areas.map(id => `idAreas=${encodeURIComponent(id)}`).join('&');

      const params = [
        `desde=${desdeQS}`,
        `hasta=${hastaQS}`,
        idsMaquinasQS,
        idsAreasQS
      ].filter(Boolean).join('&');

      axios
        .get(`/Reportes/ObtenerResumenFTQNyx?${params}`)
        .then(response => this.ftq = response.data)
        .catch(error => console.log(error))
        .finally(() => {
        });
    },

    formatFecha(key) {
      // key: 'YYYY-MM-DD' -> 'DD/MM/YYYY'
      const [y, m, d] = key.split('-');
      return `${d}/${m}/${y}`;
    },

    // Usa tu getColor existente; si no existiera, aplica los umbrales por defecto
    // Paleta accesible; si prefieres la tuya, cambia estos hex.
    cellBg(oee) {
      if (oee == null) return '#bdbdbd';    // gris sin dato
      if (oee >= 85) return '#2e7d32';     // verde oscuro (mejor para texto claro)
      if (oee >= 70) return '#f1c40f';     // amarillo (texto oscuro)
      if (oee >= 50) return '#ef6c00';     // naranja oscuro
      return '#c62828';                     // rojo oscuro
    },

    // Contraste WCAG: elige blanco/negro según luminancia relativa
    cellFg(oee) {
      const hex = this.cellBg(oee).replace('#', '');
      const rgb = [0, 2, 4].map(i => parseInt(hex.substr(i, 2), 16) / 255)
        .map(v => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)));
      const L = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
      // umbral ~0.5: amarillos/claros -> texto oscuro; oscuros -> texto claro
      return L > 0.5 ? '#111' : '#fff';
    },

    getColor(oee) {
      if (oee == null) return '#9e9e9e'; // sin dato
      if (oee >= 85) return '#2ecc71';   // verde
      if (oee >= 70) return '#f1c40f';   // amarillo
      if (oee >= 50) return '#e67e22';   // naranja
      return '#e74c3c';                  // rojo
    },

    getDayKey(r) {
      const s = r.inicio || r.fechaInvolucrada || r.fecha || r.desde || r.fechaInicio;
      return s ? String(s).slice(0, 10) : null; // YYYY-MM-DD
    },

    // Detecta el lado a partir de 'cavidad' (o campos similares)
    getSide(r) {
      const raw = (r.cavidad || r.lado || r.ladoNombre || r.posicion || '').toString();
      if (/izq|izquierda|left|^i$|^l$/i.test(raw)) return 'izq';
      if (/der|derecha|right|^d$|^r$/i.test(raw)) return 'der';
      return null;
    },

    // Ya la tienes:
    formatFecha(key) {
      const [y, m, d] = key.split('-');
      return `${d}/${m}/${y}`;
    },

    // Detecta campos para OK y lado (soporta varias convenciones)
    extractOk(r) {
      const take = (obj, keys) => {
        for (const k of keys) if (k in obj && obj[k] != null) return Number(obj[k]) || 0;
        return null;
      };

      // A) Dos campos separados IZQ/DER en la fila
      const izq = take(r, [
        'pzaRealizadasIzq', 'pzasOkIzq', 'piezasOkIzq',
        'pzasBuenasIzq', 'piezasBuenasIzq', 'okIzq', 'buenasIzq'
      ]);
      const der = take(r, [
        'pzaRealizadasDer', 'pzasOkDer', 'piezasOkDer',
        'pzasBuenasDer', 'piezasBuenasDer', 'okDer', 'buenasDer'
      ]);
      if (izq != null || der != null) {
        return { mode: 'split', izq: izq || 0, der: der || 0 };
      }

      // B) Un solo valor + un campo que indica el lado
      const val = take(r, [
        'pzaRealizadas', 'pzasOk', 'piezasOk', 'ok', 'buenas',
        'pzasBuenas', 'piezasBuenas', 'piezasRealizadas'
      ]);
      const sideRaw = (
        r.cavidad || r.lado || r.ladoNombre || r.posicion || r.cav || ''
      ).toString();

      if (val != null) {
        if (/izq|izquierda|left|^i$|^l$/i.test(sideRaw)) return { side: 'izq', value: val };
        if (/der|derecha|right|^d$|^r$/i.test(sideRaw)) return { side: 'der', value: val };
      }

      // C) No se encontró nada
      return {};
    },
    fmtPct(v) {
      return `${(Number(v) || 0).toFixed(1)}%`;
    },
    fmtDur(sec) {
      const s = Math.max(0, Math.floor(Number(sec) || 0));
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      if (d > 0) return `${d}d ${h}h ${m}m`;
      if (h > 0) return `${h}h ${m}m`;
      return `${m}m`;
    },

  }
}
</script>

<style scoped>
.oee-wrapper {
  overflow: auto;
}

/* tabla "heatmap" con tarjetas separadas */
.oee-table {
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 6px 6px;
  width: 100%;
}

/* tipografía consistente y legible */
.oee-table th,
.oee-table td {
  height: 46px;
  padding: 8px 10px;
  vertical-align: middle;
  white-space: nowrap;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

/* encabezado más visible */
.oee-table thead th {
  position: sticky;
  top: 0;
  z-index: 5;
  background: inherit;
  font-weight: 700;
}

.th-title {
  letter-spacing: .2px;
}

.th-date {
  font-size: 13px;
  font-weight: 700;
  color: rgba(0, 0, 0, .75);
  background-color: white;
}

.theme--dark .th-date {
  color: rgba(255, 255, 255, .85);
}

/* primera columna fija + estilo */
.sticky-col {
  position: sticky;
  left: 0;
  z-index: 6;
}

.left-col {
  min-width: 170px;
  background: #f5f5f5;
  /* border-radius: 8px; */
}

.theme--dark .left-col {
  background: #1e1e1e;
}

.left-text {
  font-weight: 700;
  color: rgba(0, 0, 0, .82);
}

.theme--dark .left-text {
  color: rgba(255, 255, 255, .92);
}

/* celdas KPI */
.oee-cell {
  /* border-radius: 8px; */
  box-shadow: 0 0 0 1px rgba(0, 0, 0, .06) inset;
}

/* números con ancho tabular + más gruesos */
.num {
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  font-size: 13px;
  letter-spacing: .1px;
}

.kpi-grid {
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  /* 4 filas iguales */
  gap: 8px;
  height: 100%;
  /* iguala el alto al col */
}
</style>